import { IQuestionnaire, IVisitorAgreement } from '../visitor';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export type UserRole = 'Admin' | 'Reception' | 'Visitor';

export const Roles = {
  Admin: 'Admin',
  Reception: 'Reception',
  Visitor: 'Visitor',
  Guest: 'Guest',
};

export interface ILicenseUpdatedResult {
  numberOfSites: number;
}

export interface INormalizedObjects<T> {
  byId: { [id: number]: T };
  allIds: number[];
}

export interface IVisitorTypeDetails {
  id: number;
  name: string;
  icon: IconProp;
  agreementId: number | null;
  questionnaireId: number | null;
  supplementaryQuestionnaireId: number | null;
}

export interface INormalizedVisitorTypeDetails {
  id: number;
  name: string;
  icon: IconProp;
  agreementId: number | null;
  questionnaires: Array<number>;
}

export interface ILoginResult {
  token: string;
  hasValidLicense?: boolean;
  licenseHasExpired?: boolean;
  numberOfSites?: number;
  showNagScreen?: boolean;
  daysUntilLicenseExpires?: number;
  retainDataForInDays?: number;
  dataPrivacyMessage?: string;
  visitorTypes?: Array<IVisitorTypeDetails>;
  questionnaires?: Array<IQuestionnaire>;
  agreements?: Array<IVisitorAgreement>;
}

export interface IUserData {
  hasValidLicense: boolean;
  licenseHasExpired: boolean;
  numberOfSites: number;
  showNagScreen?: boolean;
  daysUntilLicenseExpires?: number;
  retainDataForInDays?: number;
  dataPrivacyMessage?: string;
  pin: string;
  site: string;
  themeId?: number;
  role: UserRole;
  visitorTypes?: INormalizedObjects<INormalizedVisitorTypeDetails>;
  questionnaires?: INormalizedObjects<IQuestionnaire>;
  agreements?: INormalizedObjects<IVisitorAgreement>;
}

export interface IUser extends IUserData {
  isAuthenticated: boolean;
}

export interface IAuthenticationContext extends IUser {
  hasRole(role: string): boolean;
  onLogout(): void;
  onLogin(loginResult: ILoginResult, path: string): void;
  onLicenseUpdated(licenseUpdatedResult: ILicenseUpdatedResult): void;
}
